import { render, staticRenderFns } from "./AddContentCategory.vue?vue&type=template&id=6bb0c230"
import script from "./AddContentCategory.vue?vue&type=script&lang=js"
export * from "./AddContentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports